module.exports = __webpack_public_path__ + "img/150.f94eb481.jpg";